'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Repair = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-repair--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M22.7076 31.4514L9.10647 45.4761C7.63118 46.9639 7.63118 49.3962 9.10647 50.8841C10.5818 52.3719 12.9888 52.3719 14.4641 50.8841L28.1947 36.7171",
                    fill: "white"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22.7076 31.4514L9.10647 45.4761C7.63118 46.9639 7.63118 49.3962 9.10647 50.8841C10.5818 52.3719 12.9888 52.3719 14.4641 50.8841L28.1947 36.7171",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M13.5712 46.3817L12.0312 47.9343",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "bevel"
                }),
                jsxRuntime.jsx("path", {
                    d: "M12.7041 8.66785L10.8923 10.4921L9.08057 12.3293L14.4382 21.4116L18.7347 21.5798L33.19 36.1608L34.7688 34.5694L36.3476 32.991L21.8794 18.3971L21.7111 14.0759L12.7041 8.66785Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M38.5346 30.9727L31.1582 38.412C30.8346 38.7354 30.8346 39.2529 31.1582 39.5764L33.0217 41.4653C33.1899 41.6335 33.4358 41.724 33.6688 41.6982L35.3641 41.5429L44.6558 50.9099C46.0793 52.346 48.4088 52.346 49.8323 50.9099L50.9323 49.7973C52.3558 48.3612 52.3558 46.0194 50.9323 44.5833L41.6405 35.2163L41.7829 33.5085C41.8088 33.2627 41.7182 33.0298 41.5499 32.8487L39.6864 30.9597C39.3629 30.6363 38.8452 30.6363 38.5346 30.9597V30.9727Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M39.0522 38.9296L47.4381 47.3909",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M36.7876 27.8806L38.4958 26.0952C41.8605 27.4666 45.8593 26.7809 48.5899 24.0381C51.5923 21.0106 52.1875 16.3142 50.0134 12.614C49.9617 12.5363 49.897 12.4846 49.8323 12.4199L44.3581 17.9444L41.4593 15.0204L46.9334 9.49595C46.8687 9.43126 46.817 9.36657 46.7393 9.31482C43.077 7.12832 38.4181 7.71053 35.4158 10.7509C32.6981 13.4937 32.0123 17.5304 33.3711 20.9201L31.5981 22.7702",
                    fill: "white"
                }),
                jsxRuntime.jsx("path", {
                    d: "M36.7876 27.8806L38.4958 26.0952C41.8605 27.4666 45.8593 26.7809 48.5899 24.0381C51.5923 21.0106 52.1875 16.3142 50.0134 12.614C49.9617 12.5363 49.897 12.4846 49.8323 12.4199L44.3581 17.9444L41.4593 15.0204L46.9334 9.49595C46.8687 9.43126 46.817 9.36657 46.7393 9.31482C43.077 7.12832 38.4181 7.71053 35.4158 10.7509C32.6981 13.4937 32.0123 17.5304 33.3711 20.9201L31.5981 22.7702",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-repair",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M22.7076 31.4514L9.10647 45.4761C7.63118 46.9639 7.63118 49.3962 9.10647 50.8841C10.5818 52.3719 12.9888 52.3719 14.4641 50.8841L28.1947 36.7171",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M22.7076 31.4514L9.10647 45.4761C7.63118 46.9639 7.63118 49.3962 9.10647 50.8841C10.5818 52.3719 12.9888 52.3719 14.4641 50.8841L28.1947 36.7171",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13.5712 46.3817L12.0312 47.9343",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "bevel"
            }),
            jsxRuntime.jsx("path", {
                d: "M12.7041 8.66785L10.8923 10.4921L9.08057 12.3293L14.4382 21.4116L18.7347 21.5798L33.19 36.1608L34.7688 34.5694L36.3476 32.991L21.8794 18.3971L21.7111 14.0759L12.7041 8.66785Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M38.5346 30.9727L31.1582 38.412C30.8346 38.7354 30.8346 39.2529 31.1582 39.5764L33.0217 41.4653C33.1899 41.6335 33.4358 41.724 33.6688 41.6982L35.3641 41.5429L44.6558 50.9099C46.0793 52.346 48.4088 52.346 49.8323 50.9099L50.9323 49.7973C52.3558 48.3612 52.3558 46.0194 50.9323 44.5833L41.6405 35.2163L41.7829 33.5085C41.8088 33.2627 41.7182 33.0298 41.5499 32.8487L39.6864 30.9597C39.3629 30.6363 38.8452 30.6363 38.5346 30.9597V30.9727Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M39.0522 38.9296L47.4381 47.3909",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M36.7876 27.8806L38.4958 26.0952C41.8605 27.4666 45.8593 26.7809 48.5899 24.0381C51.5923 21.0106 52.1875 16.3142 50.0134 12.614C49.9617 12.5363 49.897 12.4846 49.8323 12.4199L44.3581 17.9444L41.4593 15.0204L46.9334 9.49595C46.8687 9.43126 46.817 9.36657 46.7393 9.31482C43.077 7.12832 38.4181 7.71053 35.4158 10.7509C32.6981 13.4937 32.0123 17.5304 33.3711 20.9201L31.5981 22.7702",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M36.7876 27.8806L38.4958 26.0952C41.8605 27.4666 45.8593 26.7809 48.5899 24.0381C51.5923 21.0106 52.1875 16.3142 50.0134 12.614C49.9617 12.5363 49.897 12.4846 49.8323 12.4199L44.3581 17.9444L41.4593 15.0204L46.9334 9.49595C46.8687 9.43126 46.817 9.36657 46.7393 9.31482C43.077 7.12832 38.4181 7.71053 35.4158 10.7509C32.6981 13.4937 32.0123 17.5304 33.3711 20.9201L31.5981 22.7702",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = Repair;
